// Persist the ?ref= URL parameter across in-app navigation.
// Users land on `/?ref=12345`, click Register & Invest, get sent to
// `/invest` (without the query). sessionStorage keeps the referrer.

const KEY = 'zenova_ref';

export const captureRefFromUrl = () => {
  try {
    const params = new URLSearchParams(window.location.search);
    const r = params.get('ref');
    if (r && /^\d+$/.test(r)) {
      sessionStorage.setItem(KEY, r);
    }
  } catch (e) {
    // sessionStorage may be blocked (private mode) — silently ignore
  }
};

export const readStoredRef = () => {
  try {
    return sessionStorage.getItem(KEY) || '';
  } catch (e) {
    return '';
  }
};

export const clearStoredRef = () => {
  try {
    sessionStorage.removeItem(KEY);
  } catch (e) {}
};
